module.exports = __webpack_public_path__ + "media/front/images/phone-solid-088b89ec3cf6b5f91cf2887f962048ee.svg";